<template>
	<div
		v-if="shouldDisplay"
		:class="[
			`relative font-ivy-display ${blok.height} relative main-wrapper ${blok.full_width ? 'full-bleed' : ''} ${blok.visibility ? blok.visibility.join(' ') : ''}`,
			`${blok.font || ''}`
		]"
		:style="inlineStyles"
	>
		<!-- Background Image -->
		<NuxtImg
			v-if="blok?.image?.[0]?.image?.filename"
			:src="blok.image[0].image.filename"
			:alt="blok.image[0].image.alt || 'hero'"
			class="w-full h-full object-cover absolute inset-0"
			provider="storyblok"
			preload
			loading="eager"
			format="webp"
			sizes="sm:80vw md:70vw lg:80vw"
			:width="storyblokImgDimensions.width"
			:height="storyblokImgDimensions.height"
		/>

		<!-- Content Over Image -->
		<div
			:class="[
				`${blok.height} flex flex-col justify-end container mx-auto absolute inset-0 ${blok.is_opacity ? 'bg-black/25' : ''}`
			]"
		>
			<div
				class="w-full flex flex-col justify-center items-center pb-16 text-white gap-2"
			>
				<span class="text-base font-semibold">{{ blok.sub_heading }}</span>

				<div class="mb-6 text-center">
					<StoryblokComponent
						v-for="heading in blok.heading"
						:key="heading._uid"
						:blok="heading"
					/>
				</div>
				<StoryblokComponent
					v-for="call_to_action in blok.call_to_action"
					:key="call_to_action._uid"
					:blok="call_to_action"
				/>
				<CountdownBlock
					v-if="blok.countdown_start_date"
					:start-date="blok.countdown_start_date"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { BlokHero } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokHero;
}
const { blok } = defineProps<Props>();

const { shouldDisplay } = useDisplayBlock(blok.start_date, blok.end_date);

const storyblokImgDimensions = computed(() => {
	const fileName = blok?.image[0]?.image?.filename?.split("/")?.[5]?.split("x");
	return {
		width: fileName?.[0],
		height: fileName?.[1]
	};
});

const inlineStyles = computed(() => {
	const bgColor =
		blok.background_color?.value || blok.background_color_hex?.color;

	return {
		...(bgColor && blok.enable_background_color
			? { backgroundColor: bgColor }
			: {})
	};
});
</script>
